import "@Styles/Main.less"

import DataWebPage from "@Scripts/Pages/DataWebPage";
import BasePage from "@Scripts/Pages/BasePage";

let App: any = {
    instances: {},
    pages: {},
    routes: {}
};

App.pages.DataWebPage = DataWebPage;
App.pages.BasePage = BasePage;

(<any>window).App = App;